import { createContext, useContext, useState, useEffect } from 'react';
import { useStatelessGet } from 'hooks/useStatelessGet';
import { ResponseEnvelope } from 'types/ResponseEnvelope';
import { Country } from 'types/Country';

interface ApplicantContextData {
  countriesList: Country[];
  countryMap: Map<number, Country>;
}

const CountriesContext = createContext<ApplicantContextData | undefined>(undefined);

export const CountriesProvider = ({ children }) => {
  const [countriesList, setCountriesList] = useState<Country[]>([]);
  const [countryMap, setCountryMap] = useState<Map<number, Country>>(new Map());
  const getCountries = useStatelessGet<ResponseEnvelope<Country[]>>(`/countries`, {
    skipAuth: true,
  });

  const sortNameAlphabetic = (a: Country, b: Country) => a.name.toLowerCase().localeCompare(b.name.toLowerCase());

  useEffect(() => {
    getCountries().then((response) => {
      setCountriesList(response.data.sort(sortNameAlphabetic));
      const map = new Map();
      response.data.forEach((country) => map.set(country.id, country));
      setCountryMap(map);
    });
  }, [getCountries]);

  return <CountriesContext.Provider value={{ countriesList, countryMap }}>{children}</CountriesContext.Provider>;
};

export const useCountries = () => {
  const context = useContext(CountriesContext);

  if (context === undefined) {
    throw new Error('useCountries was used outside of its Provider');
  }
  return context;
};
